import {
  useCallback,
  useEffect
} from 'react'

import { useDraftState } from 'hooks/useDraftState'
import {
  error,
  isObject
} from 'utils'
import { isFunction } from 'utils'
import {
  getQueryStringValues,
  setQueryStringValue
} from 'utils/queryString'

export const useQueryStringState = (initialValue)  => {
  if(!isObject(initialValue)) {
    error(new Error(`useQueryString: the initialValue must be an object.`))
  }

  const existingQueryStringValues = getQueryStringValues(Object.keys(initialValue))
  const [value, updateValue] = useDraftState({
    ...initialValue,
    ...existingQueryStringValues
  })


  useEffect(() => {
    setQueryStringValue(value)
  }, [value])

  return [
    value,
    useCallback(updater => {
      if (!isFunction(updater)) {
        return updateValue(() => updater)
      }
      updateValue(updater)
    }, [updateValue])
  ]
}
